import { Period } from "@rossum/upcloud-costs-shared";

/** The month shown by default: the latest closed month, or the latest month when none is closed. */
export function defaultMonth(periods: readonly Period[]): string | undefined {
    return (periods.find((period) => period.closed) ?? periods[0])?.month;
}
